import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { ROUTES } from '@/constants';
import { PREVIEW_SIZE } from '../../constants';
import type { PolicyData } from '../PolicySearch/SearchPolicyCard';
import { SearchPolicyCard } from '../PolicySearch/SearchPolicyCard';
import { SearchPolicyCardSkeletonList } from '../PolicySearch/SearchPolicyCardSkeleton';
import { SectionHeader } from './SectionHeader';
export function PolicyPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== keyword) {
    t1 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "policy"
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalCount) {
    t2 = <SectionHeader title={"\uC815\uCC45"} totalCount={totalCount} moreHref={t1} />;
    $[2] = t1;
    $[3] = totalCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== items) {
    t3 = isLoading ? <SearchPolicyCardSkeletonList count={PREVIEW_SIZE} /> : <div className="flex flex-col gap-12 mobile-tablet:gap-0">{items.map((policy, idx) => <Fragment key={policy.id}><SearchCategoryAdSlot placement="search-all-policy" position={idx + 1} listLength={items.length} className="mx-auto" /><SearchPolicyCard policy={policy} /></Fragment>)}</div>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <section className="flex w-full flex-col">{t2}{t3}</section>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}